import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 md:right-8 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line" aria-hidden="true"></i>
    </button>
  );
}